module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e194415"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Burk_9781418513399_epub_c3_r1#Anch00315",
      "id": "Anch0023"
    }
  }, [_c('b', [_vm._v("Part 1")]), _c('br'), _c('b', [_vm._v("BUSINESS")]), _c('br'), _c('b', [_vm._v("BY THE")]), _c('br'), _c('b', [_vm._v("BOOK")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-217bcf5c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Burk_9781418513399_epub_c8_r1.vue
// module id = 72
// module chunks = 0